import { MoreHorizontal } from 'lucide-react'
import { Children, createContext, useState } from 'react'

import { Button } from '@klear/ui/components/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@klear/ui/components/dropdown-menu'

interface DataTableRowActionsContext {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
}

const RowActionsContext = createContext<DataTableRowActionsContext | undefined>(undefined)

interface DataTableRowActionsProps {
  children: React.ReactNode
}

export function DataTableRowActions({ children }: DataTableRowActionsProps) {
  const [isOpen, setIsOpen] = useState(false)

  const hasActions = Children.toArray(children).some(Boolean)

  return (
    <RowActionsContext.Provider value={{ isOpen, setIsOpen }}>
      <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
            onClick={(e) => e.stopPropagation()}
            onPointerDown={(e) => e.stopPropagation()}
          >
            <MoreHorizontal />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-[160px]" onCloseAutoFocus={(e) => e.preventDefault()}>
          {hasActions ? (
            children
          ) : (
            <DropdownMenuItem disabled className="text-muted-foreground">
              No actions available
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </RowActionsContext.Provider>
  )
}
